import { SET_ERROR_MESSAGE, ISetErrorMessage } from "./errors-types";

export const setErrorMessage = (errorMessage: string): ISetErrorMessage => ({
    type: SET_ERROR_MESSAGE,
    // This regex expression will only remove the quotes if they are the first and last characters of the string.
    errorMessage: errorMessage.replace(/^"(.*)"$/, "$1"),
});
